import { useLanguagePath } from "hooks/useLanguagePath";

interface ICustomWindowOpen {
  url: string;
  target?: "_self" | "_blank";
  isExternal?: boolean;
  features?: string;
}

/**
 * Custom window.open wrapper that handles language routing for internal links
 * @param url - The URL to open
 * @param target - Window target (_self or _blank), defaults to _blank
 * @param isExternal - If true, opens URL as-is without language prefix
 * @param features - Optional window features string
 */
const useCustomWindowOpen = () => {
  const { getLocalizedPath } = useLanguagePath();

  const customWindowOpen = ({
    url,
    target = "_blank",
    isExternal = false,
    features,
  }: ICustomWindowOpen): Window | null => {
    if (!url) return null;

    // Use URL as-is for external links
    const finalUrl = isExternal ? url : getLocalizedPath(url);

    return window.open(finalUrl, target, features);
  };

  return customWindowOpen;
};

export default useCustomWindowOpen;
